export const MY_AFFILATE_LIST = 'MY_AFFILATE_LIST';
export const MY_AFFILATE_INFO = 'MY_AFFILATE_INFO';
export const UPDATE_PAYMENT_INFO = 'UPDATE_PAYMENT_INFO';
export const ACTIVE_AFFILATE = 'ACTIVE_AFFILATE';
export const UPDATE_AFFILATE = 'UPDATE_AFFILATE';

